import { Injectable } from '@angular/core';

import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { from, combineLatest, Observable, throwError } from 'rxjs';
import { take, map, catchError } from 'rxjs/operators';
import Resource from '../interfaces/Resource';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ResourceService {
  constructor(private afs: AngularFirestore, private http: HttpClient) {}

  createResource(d: Resource) {
    return new Promise((resolve, reject) => {
      this.afs
        .collection('resources')
        .add(d)
        .then((dRef) => {
          dRef.update({ id: dRef.id }).then(() => {
            resolve(dRef.id);
          });
        })
        .catch((e) => reject(e));
    });
  }

  updateResource(dId, d) {
    const resourceRef: AngularFirestoreDocument<any> = this.afs.doc(`/resources/${dId}`);
    return resourceRef.update(d);
  }

  getResource(id) {
    return new Promise((resolve, reject) => {
      const resourceRef: AngularFirestoreDocument<any> = this.afs.doc(`resources/${id}`);
      resourceRef.get().subscribe(
        (ds) => {
          resolve(ds.data());
        },
        (e) => reject(e)
      );
    });
  }

  getResources(limit): Observable<Array<Resource>> {
    const resourcesRef: AngularFirestoreCollection<any> = this.afs.collection('resources', (ref) =>
      ref.orderBy('timestamp', 'desc').limit(limit)
    );
    return resourcesRef.get().pipe(
      map((r) => {
        return r.docs.map((doc) => {
          return doc.data() as Resource;
        });
      })
    );
  }

  getResourcesByApproach(approach, limit) {
    const resourcesRef: AngularFirestoreCollection<any> = this.afs.collection('resources', (ref) =>
      ref.where('approaches', 'array-contains', approach).orderBy('timestamp', 'desc').limit(limit)
    );
    return from(resourcesRef.valueChanges().pipe(take(1)));
  }
  getAllResources() {
    const resourcesRef: AngularFirestoreCollection<any> = this.afs.collection('resources', (ref) =>
      ref.orderBy('timestamp', 'desc')
    );
    return from(resourcesRef.valueChanges().pipe(take(1)));
  }

  getUserResources(uid) {
    return from(
      this.afs
        .collection('users', (ref) => ref.where('owner', '==', uid))
        .valueChanges()
        .pipe(take(1))
    );
  }

  getResourceMeta(resourceUrl): Observable<any> {
    if (!resourceUrl.startsWith('http')) resourceUrl = 'http://' + resourceUrl
    const postUrl = 'https://us-central1-ocean-cdr.cloudfunctions.net/url-meta';
    return this.http.post(postUrl, { url: resourceUrl });
  }

  deleteResource(id) {
    const resourceRef: AngularFirestoreDocument<any> = this.afs.doc(`/resources/${id}`);
    return resourceRef.delete();
  }
}
